export default "__VITE_ASSET__RVXmHzQ2__"